<!-- Classy -->
<app-classy-layout *ngIf="layout === 'classy'"></app-classy-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<app-empty-layout *ngIf="layout === 'empty'"></app-empty-layout>
